import _classCallCheck from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/abhishekpandit/Desktop/Quadb Tech/ton-wallet-kaios/ton-frontend/node_modules/kaios-scripts/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/* eslint-disable prefer-template */
import Transport from "@ledgerhq/hw-transport";
import { DisconnectedDevice, TransportOpenUserCancelled } from "@ledgerhq/errors";
import { getBluetoothServiceUuids, getInfosForServiceUuid } from "@ledgerhq/devices";
import { sendAPDU } from "@ledgerhq/devices/lib/ble/sendAPDU";
import { receiveAPDU } from "@ledgerhq/devices/lib/ble/receiveAPDU";
import { log } from "@ledgerhq/logs";
import { Observable, defer, merge, from } from "rxjs";
import { share, ignoreElements, first, map, tap } from "rxjs/operators";
import { monitorCharacteristic } from "./monitorCharacteristic";
var requiresBluetooth = function requiresBluetooth() {
  // $FlowFixMe
  var _navigator = navigator,
    bluetooth = _navigator.bluetooth;
  if (typeof bluetooth === "undefined") {
    throw new Error("web bluetooth not supported");
  }
  return bluetooth;
};
var availability = function availability() {
  return Observable.create(function (observer) {
    var bluetooth = requiresBluetooth();
    var onAvailabilityChanged = function onAvailabilityChanged(e) {
      observer.next(e.value);
    };
    bluetooth.addEventListener("availabilitychanged", onAvailabilityChanged);
    var unsubscribed = false;
    bluetooth.getAvailability().then(function (available) {
      if (!unsubscribed) {
        observer.next(available);
      }
    });
    return function () {
      unsubscribed = true;
      bluetooth.removeEventListener("availabilitychanged", onAvailabilityChanged);
    };
  });
};
var transportsCache = {};
var requestDeviceParam = function requestDeviceParam() {
  return {
    filters: getBluetoothServiceUuids().map(function (uuid) {
      return {
        services: [uuid]
      };
    })
  };
};
var retrieveService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(device) {
    var _yield$device$gatt$ge, _yield$device$gatt$ge2, service, infos;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (device.gatt) {
            _context.next = 2;
            break;
          }
          throw new Error("bluetooth gatt not found");
        case 2:
          _context.next = 4;
          return device.gatt.getPrimaryServices();
        case 4:
          _yield$device$gatt$ge = _context.sent;
          _yield$device$gatt$ge2 = _slicedToArray(_yield$device$gatt$ge, 1);
          service = _yield$device$gatt$ge2[0];
          if (service) {
            _context.next = 9;
            break;
          }
          throw new Error("bluetooth service not found");
        case 9:
          infos = getInfosForServiceUuid(service.uuid);
          if (infos) {
            _context.next = 12;
            break;
          }
          throw new Error("bluetooth service infos not found");
        case 12:
          return _context.abrupt("return", [service, infos]);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function retrieveService(_x) {
    return _ref.apply(this, arguments);
  };
}();
function _open2(_x2, _x3) {
  return _open.apply(this, arguments);
}
/**
 * react-native bluetooth BLE implementation
 * @example
 * import BluetoothTransport from "@ledgerhq/hw-transport-web-ble";
 */
function _open() {
  _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(deviceOrId, needsReconnect) {
    var device, bluetooth, _yield$retrieveServic, _yield$retrieveServic2, service, infos, deviceModel, writeUuid, notifyUuid, _yield$Promise$all, _yield$Promise$all2, writeC, notifyC, notifyObservable, notif, transport, onDisconnect, beforeMTUTime, afterMTUTime;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!(typeof deviceOrId === "string")) {
            _context10.next = 10;
            break;
          }
          if (!transportsCache[deviceOrId]) {
            _context10.next = 4;
            break;
          }
          log("ble-verbose", "Transport in cache, using that.");
          return _context10.abrupt("return", transportsCache[deviceOrId]);
        case 4:
          bluetooth = requiresBluetooth(); // TODO instead we should "query" the device by its ID
          _context10.next = 7;
          return bluetooth.requestDevice(requestDeviceParam());
        case 7:
          device = _context10.sent;
          _context10.next = 11;
          break;
        case 10:
          device = deviceOrId;
        case 11:
          if (device.gatt.connected) {
            _context10.next = 15;
            break;
          }
          log("ble-verbose", "not connected. connecting...");
          _context10.next = 15;
          return device.gatt.connect();
        case 15:
          _context10.next = 17;
          return retrieveService(device);
        case 17:
          _yield$retrieveServic = _context10.sent;
          _yield$retrieveServic2 = _slicedToArray(_yield$retrieveServic, 2);
          service = _yield$retrieveServic2[0];
          infos = _yield$retrieveServic2[1];
          deviceModel = infos.deviceModel, writeUuid = infos.writeUuid, notifyUuid = infos.notifyUuid;
          _context10.next = 24;
          return Promise.all([service.getCharacteristic(writeUuid), service.getCharacteristic(notifyUuid)]);
        case 24:
          _yield$Promise$all = _context10.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          writeC = _yield$Promise$all2[0];
          notifyC = _yield$Promise$all2[1];
          notifyObservable = monitorCharacteristic(notifyC).pipe(tap(function (value) {
            log("ble-frame", "<= " + value.toString("hex"));
          }), share());
          notif = notifyObservable.subscribe();
          transport = new BluetoothTransport(device, writeC, notifyObservable, deviceModel);
          if (device.gatt.connected) {
            _context10.next = 33;
            break;
          }
          throw new DisconnectedDevice();
        case 33:
          // eslint-disable-next-line require-atomic-updates

          transportsCache[transport.id] = transport;
          onDisconnect = function onDisconnect(e) {
            console.log("onDisconnect!", e);
            delete transportsCache[transport.id];
            transport.notYetDisconnected = false;
            notif.unsubscribe();
            device.removeEventListener("gattserverdisconnected", onDisconnect);
            log("ble-verbose", "BleTransport(".concat(transport.id, ") disconnected"));
            transport.emit("disconnect", e);
          };
          device.addEventListener("gattserverdisconnected", onDisconnect);
          beforeMTUTime = Date.now();
          _context10.prev = 37;
          _context10.next = 40;
          return transport.inferMTU();
        case 40:
          _context10.prev = 40;
          afterMTUTime = Date.now(); // workaround for #279: we need to open() again if we come the first time here,
          // to make sure we do a disconnect() after the first pairing time
          // because of a firmware bug
          if (afterMTUTime - beforeMTUTime < 1000) {
            needsReconnect = false; // (optim) there is likely no new pairing done because mtu answer was fast.
          }
          if (!needsReconnect) {
            _context10.next = 48;
            break;
          }
          _context10.next = 46;
          return device.gatt.disconnect();
        case 46:
          _context10.next = 48;
          return new Promise(function (s) {
            return setTimeout(s, 4000);
          });
        case 48:
          return _context10.finish(40);
        case 49:
          if (!needsReconnect) {
            _context10.next = 51;
            break;
          }
          return _context10.abrupt("return", _open2(device, false));
        case 51:
          return _context10.abrupt("return", transport);
        case 52:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[37,, 40, 49]]);
  }));
  return _open.apply(this, arguments);
}
var BluetoothTransport = /*#__PURE__*/function (_Transport) {
  _inherits(BluetoothTransport, _Transport);
  _createClass(BluetoothTransport, null, [{
    key: "listen",
    /**
     * observe event with { available: bool, type: string }
     * (available is generic, type is specific)
     * an event is emit once and then each time it changes
     */
    /**
     * Scan for Ledger Bluetooth devices.
     * On this web implementation, it only emits ONE device, the one that was selected in the UI (if any).
     */
    value: function listen(observer) {
      log("ble-verbose", "listen...");
      var unsubscribed;
      var bluetooth = requiresBluetooth();
      bluetooth.requestDevice(requestDeviceParam()).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(device) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!unsubscribed) {
                  observer.next({
                    type: "add",
                    descriptor: device
                  });
                  observer.complete();
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }(), function (error) {
        observer.error(new TransportOpenUserCancelled(error.message));
      });
      function unsubscribe() {
        unsubscribed = true;
      }
      return {
        unsubscribe: unsubscribe
      };
    }
    /**
     * open a bluetooth device.
     */
  }, {
    key: "open",
    value: function () {
      var _open3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(deviceOrId) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _open2(deviceOrId, true));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function open(_x5) {
        return _open3.apply(this, arguments);
      }
      return open;
    }()
    /**
     * globally disconnect a bluetooth device by its id.
     */
  }]);
  function BluetoothTransport(device, writeCharacteristic, notifyObservable, deviceModel) {
    var _this;
    _classCallCheck(this, BluetoothTransport);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BluetoothTransport).call(this));
    _this.id = void 0;
    _this.device = void 0;
    _this.mtuSize = 20;
    _this.writeCharacteristic = void 0;
    _this.notifyObservable = void 0;
    _this.notYetDisconnected = true;
    _this.deviceModel = void 0;
    _this.exchange = function (apdu) {
      return _this.exchangeAtomicImpl( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var msgIn, data, msgOut;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              msgIn = apdu.toString("hex");
              log("apdu", "=> ".concat(msgIn));
              _context4.next = 5;
              return merge(_this.notifyObservable.pipe(receiveAPDU), sendAPDU(_this.write, apdu, _this.mtuSize)).toPromise();
            case 5:
              data = _context4.sent;
              msgOut = data.toString("hex");
              log("apdu", "<= ".concat(msgOut));
              return _context4.abrupt("return", data);
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              log("ble-error", "exchange got " + String(_context4.t0));
              if (_this.notYetDisconnected) {
                // in such case we will always disconnect because something is bad.
                _this.device.gatt.disconnect();
              }
              throw _context4.t0;
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11]]);
      })));
    };
    _this.write = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(buffer) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              log("ble-frame", "=> " + buffer.toString("hex"));
              _context5.next = 3;
              return _this.writeCharacteristic.writeValue(buffer);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x6) {
        return _ref4.apply(this, arguments);
      };
    }();
    _this.id = device.id;
    _this.device = device;
    _this.writeCharacteristic = writeCharacteristic;
    _this.notifyObservable = notifyObservable;
    _this.deviceModel = deviceModel;
    log("ble-verbose", "BleTransport(".concat(String(_this.id), ") new instance"));
    return _this;
  }
  _createClass(BluetoothTransport, [{
    key: "inferMTU",
    value: function () {
      var _inferMTU = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this2 = this;
        var mtu, mtuSize;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              mtu = 23;
              _context7.next = 3;
              return this.exchangeAtomicImpl( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.prev = 0;
                      _context6.next = 3;
                      return merge(_this2.notifyObservable.pipe(first(function (buffer) {
                        return buffer.readUInt8(0) === 0x08;
                      }), map(function (buffer) {
                        return buffer.readUInt8(5);
                      })), defer(function () {
                        return from(_this2.write(Buffer.from([0x08, 0, 0, 0, 0])));
                      }).pipe(ignoreElements())).toPromise();
                    case 3:
                      _context6.t0 = _context6.sent;
                      mtu = _context6.t0 + 3;
                      _context6.next = 12;
                      break;
                    case 7:
                      _context6.prev = 7;
                      _context6.t1 = _context6["catch"](0);
                      log("ble-error", "inferMTU got " + String(_context6.t1));
                      _this2.device.gatt.disconnect();
                      throw _context6.t1;
                    case 12:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6, null, [[0, 7]]);
              })));
            case 3:
              if (mtu > 23) {
                mtuSize = mtu - 3;
                log("ble-verbose", "BleTransport(".concat(String(this.id), ") mtu set to ").concat(String(mtuSize)));
                this.mtuSize = mtuSize;
              }
              return _context7.abrupt("return", this.mtuSize);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function inferMTU() {
        return _inferMTU.apply(this, arguments);
      }
      return inferMTU;
    }()
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */
  }, {
    key: "setScrambleKey",
    value: function setScrambleKey() {}
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.exchangeBusyPromise) {
                _context8.next = 3;
                break;
              }
              _context8.next = 3;
              return this.exchangeBusyPromise;
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }]);
  return BluetoothTransport;
}(Transport);
export { BluetoothTransport as default };
BluetoothTransport.isSupported = function () {
  return Promise.resolve().then(requiresBluetooth).then(function () {
    return true;
  }, function () {
    return false;
  });
};
BluetoothTransport.observeAvailability = function (observer) {
  return availability.subscribe(observer);
};
BluetoothTransport.list = function () {
  return Promise.resolve([]);
};
BluetoothTransport.disconnect = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(id) {
    var transport;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          log("ble-verbose", "user disconnect(".concat(id, ")"));
          transport = transportsCache[id];
          if (transport) {
            transport.device.gatt.disconnect();
          }
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function (_x7) {
    return _ref6.apply(this, arguments);
  };
}();